

import { CommonModule } from "@angular/common";
import { HttpModule } from "@angular/http";
import { ButtonModule, SharedModule, ProgressSpinnerModule, InputTextModule, TabViewModule } from "primeng/primeng";
import { SibGridModule } from '../../../components/sib-forms/grid/grid.module';
import { NgModule } from '@angular/core';
import { DirectiveModules } from '../../../modules/directive.modules';
import { CreditNotesTasksCardsComponent } from './credit-notes-tasks-cards.component';
@NgModule({
    imports: [
        CommonModule,
        HttpModule,
        ButtonModule,
        SibGridModule,
        SharedModule,
        InputTextModule,
        ProgressSpinnerModule,
        TabViewModule,
        DirectiveModules
    ],

    declarations: [
        CreditNotesTasksCardsComponent,
    ],

    exports: [
        CreditNotesTasksCardsComponent
    ],

    providers: []
})

export class CreditNotesTaskCardModule { }
